import { StyleSheet } from 'react-native';
import { BLACK_500, WHITE } from '../../../../constants/colors';
export var getSingleDotIndictorStyle = function getSingleDotIndictorStyle(props, isActive) {
  if (isActive === void 0) {
    isActive = false;
  }
  var _props$horizontalSpac = props.horizontalSpacing,
    horizontalSpacing = _props$horizontalSpac === void 0 ? 4 : _props$horizontalSpac,
    _props$inActiveColor = props.inActiveColor,
    inActiveColor = _props$inActiveColor === void 0 ? WHITE : _props$inActiveColor,
    _props$inActiveSize = props.inActiveSize,
    inActiveSize = _props$inActiveSize === void 0 ? 8 : _props$inActiveSize,
    _props$inActiveBorder = props.inActiveBorderColor,
    inActiveBorderColor = _props$inActiveBorder === void 0 ? BLACK_500 : _props$inActiveBorder,
    activeBorderColor = props.activeBorderColor,
    _props$inActiveBorder2 = props.inActiveBorderWidth,
    inActiveBorderWidth = _props$inActiveBorder2 === void 0 ? 1 : _props$inActiveBorder2;
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      position: 'relative'
    },
    animatedView: {
      position: 'absolute',
      left: 1,
      top: 1,
      height: inActiveSize,
      width: '100%',
      marginHorizontal: horizontalSpacing
    },
    dotContainer: {
      height: inActiveSize,
      width: inActiveSize,
      borderRadius: inActiveSize / 2,
      backgroundColor: inActiveColor,
      borderWidth: inActiveBorderWidth,
      borderColor: isActive && !!activeBorderColor ? activeBorderColor : inActiveBorderColor,
      marginHorizontal: horizontalSpacing
    }
  });
};